import Vue from "vue";
import VueRouter from "vue-router";

import DashboardView from "../views/DashboardView.vue";
import RootView from "../views/RootView.vue";
import LogInView from "../views/LogInView.vue";
import SignUpView from "../views/SignUpView.vue";
import ExplorerView from "../views/ExplorerView.vue";
import OverviewView from "../views/OverviewView.vue";
import FileAnalysisInformationView from "../views/FileAnalysisInformationView.vue";
import ErrorLabelDataInformationView from "../views/ErrorLabelDataListInformationView.vue";
import SimilarityAnalysisView from "../views/SimilarityAnalysisView.vue";
import GraphView from "../views/GraphView.vue";
import ReportView from "../views/ReportView.vue";
import DemoAboutView from "../views/DemoAboutView.vue";

Vue.use(VueRouter);

// TBD : 404 Not Found 페이지
const NotFound = { template: "<div>Page Not Found</div>" };

const router = new VueRouter({
  mode: "history",
  routes: [
    { path: "/", component: RootView },
    { path: "/home", component: ExplorerView },
    { path: "/workspace/:workspaceId", component: ExplorerView },
    {
      path: "/workspace/:workspaceId/dataset/:datasetId",
      component: ExplorerView,
    },
    {
      path: "/workspace/:workspaceId/dataset/:datasetId/overview",
      component: OverviewView,
    },
    {
      path: "/workspace/:workspaceId/dataset/:datasetId/dashboard",
      component: DashboardView,
    },
    {
      path: "/workspace/:workspaceId/dataset/:datasetId/analysis/dataset",
      component: FileAnalysisInformationView,
    },
    {
      path: "/workspace/:workspaceId/dataset/:datasetId/graph",
      component: GraphView,
    },
    {
      path: "/workspace/:workspaceId/dataset/:datasetId/similarity",
      component: SimilarityAnalysisView,
    },
    {
      path: "/workspace/:workspaceId/dataset/:datasetId/report",
      component: ReportView,
    },
    {
      path: "/workspace/:workspaceId/dataset/:datasetId/labelset/:labelsetId/overview",
      component: OverviewView,
    },
    {
      path: "/workspace/:workspaceId/dataset/:datasetId/labelset/:labelsetId/dashboard",
      component: DashboardView,
    },
    {
      path: "/workspace/:workspaceId/dataset/:datasetId/labelset/:labelsetId/analysis/dataset",
      component: FileAnalysisInformationView,
    },
    {
      path: "/workspace/:workspaceId/dataset/:datasetId/labelset/:labelsetId/analysis/labelset",
      component: ErrorLabelDataInformationView,
    },
    {
      path: "/workspace/:workspaceId/dataset/:datasetId/labelset/:labelsetId/graph",
      component: GraphView,
    },
    {
      path: "/workspace/:workspaceId/dataset/:datasetId/labelset/:labelsetId/similarity",
      component: SimilarityAnalysisView,
    },
    {
      path: "/workspace/:workspaceId/dataset/:datasetId/labelset/:labelsetId/report",
      component: ReportView,
    },
    { path: "/login", component: LogInView },
    { path: "/signup", component: SignUpView },
    { path: "*", component: NotFound },
    { path: "/demo", component: DemoAboutView },
  ],
});

export default router;
